  // Full Platform List
  export const allPlatforms = [
    "All Platforms",
    "Android",
    "Apple II",
    "Atari 2600",
    "Atari 5200",
    "Atari 7800",
    "Atari 8-bit",
    "Atari Flashback",
    "Atari Lynx",
    "Atari ST",
    "Atari XEGS",
    "Classic Macintosh",
    "Commodore / Amiga",
    "Game Boy",
    "Game Boy Advance",
    "Game Boy Color",
    "GameCube",
    "iOS",
    "Linux",
    "macOS",
    "NES",
    "Nintendo 3DS",
    "Nintendo 64",
    "Nintendo DS",
    "Nintendo DSi",
    "Nintendo Switch",
    "PC",
    "PlayStation",
    "PlayStation 2",
    "PlayStation 3",
    "PlayStation 4",
    "PlayStation 5",
    "PS Vita",
    "PSP",
    "SNES",
    "Wii",
    "Wii U",
    "Xbox",
    "Xbox 360",
    "Xbox One",
    "Xbox Series S/X",
    "Meta Quest",
    "Meta Quest 2",
    "Meta Quest 3"
  ];

  // Popular genres (static)
  export const allGenres = [
    "All Genres",
    "Action",
    "Adventure",
    "RPG",
    "JRPG",
    "Action RPG",
    "Shooter",
    "First-Person Shooter",
    "Third-Person Shooter",
    "Platformer",
    "Fighting",
    "Horror",
    "Survival Horror",
    "Metroidvania",
    "Roguelike",
    "Roguelite",
    "Stealth",
    "Strategy",
    "Tactical",
    "Turn-Based",
    "Real-Time Strategy",
    "MOBA",
    "Puzzle",
    "Rhythm",
    "Simulation",
    "Life Sim",
    "Management",
    "City Builder",
    "Survival",
    "Open World",
    "Sandbox",
    "Racing",
    "Sports",
    "Party",
    "Indie",
    "Visual Novel",
    "MMO",
    "Co-op",
    "Multiplayer",
    "Story-Rich",
  ];

  // Profile tag options
  export const allProfileTags = [
    "RPG Enjoyer",
    "Indie Lover",
    "Backlog Slayer",
    "Completionist",
    "Retro Gamer",
    "Collector",
    "Casual Player",
    "Competitive",
    "Story-Driven",
    "Co-op Enjoyer",
    "JRPG Fan",
    "Soulslike Addict",
    "Survival Horror Lover",
    "Open World Explorer",
    "Achievement Hunter",
    "Speedrunner",
    "Min-Maxer",
    "Lore Enthusiast",
    "Retro Enthusiast",
    "Strategy Thinker",
    "Puzzle Solver",
    "Tactical Minded",
    "Solo Player",
    "PVP Focused",
    "Hardcore Mode",
    "Metroidvania Lover",
    "Rogue-like Enthusiast",
    "Hack & Slash Fan",
    "Platformer Enjoyer",
    "Sandbox Enjoyer",
    "Action RPG Fan",
    "Turn-Based Lover",
    "Western RPG Fan",
    "JRPG Enthusiast",
    "Choice-Based Gamer",
    "Fantasy Lover",
    "Sci-Fi Lover",
    "FPS Enjoyer",
    "Third-Person Shooter Fan",
    "Tactical Shooter Fan",
    "Battle Royale Player",
    "Arcade Shooter Lover",
    "Racing Fan",
    "Sim Racer",
    "Driving Game Enthusiast",
    "Builder / Crafter",
    "Life Sim Lover",
    "Management Sim Fan",
    "Psychological Horror Fan",
    "Zombie Slayer",
    "Meta Chaser",
    "Tech Skill Player",
    "Frame Data Nerd",
    "Ranked Mode Regular",
    "Chill Gamer",
    "Late Night Player",
    "Cozy Gamer",
    "Ambient Vibes",
    "Music Lover",
    "Collector of Aesthetics",
  ];